/**
 * Decides whether the country DDI selector should auto-select a country
 * based on locale/location signals.
 *
 * Today the only locale signal handled is Spanish (`es-ES`) /
 * `location === "ESP"`, which the caller maps to Spain. The naming is
 * generic on purpose: if additional locale-based auto-selections are
 * added later (e.g. `pt-BR` → Brazil), the rule can be extended without
 * renaming consumers.
 *
 * Triggers only when there is no incoming ddi (URL/userData) AND no
 * country already selected internally.
 */
export function shouldAutoSelectByLocale({
    ddi,
    selectedAlpha3,
    locale,
    location,
}) {
    if (ddi) return false;
    if (selectedAlpha3) return false;
    return locale === "es-ES" || location === "ESP";
}
